import { Card, Loader, Section, Typography } from '@bharatpe/bharat-ui';
import Footer from '@bharatpe/bharat-ui/web/Footer';
import PageLayout from '@bharatpe/bharat-ui/web/PageLayout';
import React, { useEffect } from 'react';
import { checkPermissions } from 'utils/nativeSupport';
import bhim from 'assets/images/autoPay/bhim.png';
import internet from 'assets/images/autoPay/internet.png';
import rupees from 'assets/images/autoPay/rupees.png';
import {
	RESET_SELECTED_SIM,
	SET_HOME_MODAL_VISIBILITY,
	SET_ONBOARDING_REDIRECTION_PAGE,
	SET_UPI_STEP,
	useUpiData,
	useUpiStatusLoading,
	useUpiStep,
} from 'Slices';
import useUpiStatus from 'Hooks/useUpiStatus';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'utils/Utils';
import { ONBOARDING_REDIRECTION_PAGE, UPISteps } from 'utils/CONSTANT';
import AllModals from '../Modals';
import history from 'utils/History';
import Toasty from 'components/atoms/Toasty';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import './styles.scss';
import AppHeader from 'components/atoms/AppHeader';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const AutoPayLanding: React.FC = () => {
	const upiStepDetails = useUpiStep();
	const upiStatus = useUpiStatus(ONBOARDING_REDIRECTION_PAGE.MANDATE);
	const { upiStep, upiErr, loading } = upiStepDetails;
	const dispatch = useDispatch();
	const upiData = useUpiData();
	const { languageData } = useLanguageConfig();
	const upiStatusLoading = useUpiStatusLoading();
	useEffect(() => {
		console.log('upiStatus', upiStatus);
	}, [upiStatus]);
	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Setup',
			Module: 'LandingPage',
			Action: 'Viewed',
		});
	}, []);
	useEffect(() => {
		if ((upiStatus?.upiErr || upiStatus?.upiStep) && isEmpty(upiStepDetails)) {
			dispatch(SET_UPI_STEP({ upiStep: upiStatus?.upiStep, upiErr: upiStatus?.upiErr, loading: loading }));
		}
	}, [dispatch, upiStatus]);

	const backEventAction = () => {
		logAnalyticsEvent({
			trigger_point: `Clicks on back button`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Setup',
			Element: 'back',
			Action: 'Tapped',
			source: 'appHeader',
		});
	};
	const setReclaimFlow = async () => {
		if (upiData?.upiProfileDetails?.user_banks[0]) {
			history.push({
				pathname: '/upi/reclaim-bank-list',
			});
		} else {
			Toasty.error('Something went wrong !!!');
		}
	};

	const handleNext = () => {
		logAnalyticsEvent({
			trigger_point: `Click on 'SETUP AUTOPAY'`,
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Setup',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'setupAutopay',
		});

		const permissions = checkPermissions();
		if (!isEmpty(upiStep)) {
			dispatch(SET_ONBOARDING_REDIRECTION_PAGE({ source: ONBOARDING_REDIRECTION_PAGE.MANDATE }));
		}
		permissions.then((data: any) => {
			if (!data.READ_PHONE_STATE || !data.SEND_SMS) {
				dispatch(
					SET_HOME_MODAL_VISIBILITY({ permissionModal: { visible: true, primaryBtnText: languageData.SETUP_AUTOPAY } }),
				);
			} else {
				if (upiErr) {
					Toasty.error(upiErr);
					dispatch(SET_HOME_MODAL_VISIBILITY({ somethingWentWrong: true }));
					return;
				}

				switch (upiStep) {
					case UPISteps.UPGRADE:
						dispatch(RESET_SELECTED_SIM());
						history.push({ pathname: '/upi/sim-binding' });
						break;
					case UPISteps.UPI_ONBOARDING_COMPLETE:
						history.push({
							pathname: '/upi/auto-pay',
						});
						break;
					case UPISteps.RECLAIM_STATUS:
						setReclaimFlow();
						break;
					case UPISteps.BANK_SCREEN:
						history.push({
							pathname: '/upi/bank-selection',
						});
						break;
				}
			}
		});
		return;
	};

	return upiStatus?.loading || upiStatusLoading ? (
		<Loader loading />
	) : (
		<PageLayout
			className="pb18 white-background "
			footerContent={<Footer primaryActionText={languageData.SETUP_AUTOPAY} primaryAction={() => handleNext()} />}>
			<>
				<AppHeader backActionToCloseDeepLink={true} title={''} backEventAction={backEventAction} />
				<AllModals />
				<div className="mx5 mt6 text-center">
					<Card className="p4 mb5 mt5 flex flex-column flex-center">
						<img src={bhim} height={50} width={50} />
						<Typography variant="Bold500" className="text-center mt4 width-100" component="span">
							{languageData.SET_UPI_AUTOPAY}
						</Typography>
						<Typography variant="Regular200" className="mt2 grey" component="span">
							{languageData.PLEASE_SETUP_UPI_AUTOPAY_IT_WILL_HELP_TO_ENSURE_TIMELY_REPAYMENT_OF_LOAN}
						</Typography>
					</Card>
					<Section title="Please Make Sure" className="mb2" noUnderline={true}>
						<Card className="p4 flex flex-column">
							<div className="flex flex-row flex-center mb4">
								<img src={internet} className="mr2" height={40} width={40} />
								<div className="flex flex-column flex-start">
									<Typography variant="Regular200" className="" component="span">
										{languageData.INTERNET_DATA_IS_ACTIVE}
									</Typography>
									<Typography variant="Light100 text-left" className="grey" component="span">
										{languageData.MAKE_SURE_MOBILE_DATA_IS_ON_AND_NETWORK_IS_HIGH}
									</Typography>
								</div>
							</div>
							<div className="flex flex-row flex-center">
								<img src={rupees} className="mr2" height={40} width={40} />
								<div className="flex flex-column flex-start">
									<Typography variant="Regular200" className="" component="span">
										{languageData.ENOUGH_BALANCE_FOR_SMS}
									</Typography>
									<Typography variant="Light100 text-left" className="grey" component="span">
										{languageData.TO_ACTIVATE_UPI_AUTOPAY_THROUGH_SMS_VERIFICATION}
									</Typography>
								</div>
							</div>
						</Card>
					</Section>
				</div>
				<div className="upi-powered-with-margin">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};
export default AutoPayLanding;
